import React, { useState, useEffect, useRef } from "react";

import { useDispatch, useSelector, shallowEqual } from "react-redux";

import { numberWithCommas } from "../../../utils/helpers";

import {
  Table,
  Tooltip,
  Tag,
  Form,
  Input,
  Button,
  Space,
  Modal,
  Descriptions,
  Divider,
  Statistic,
  Col,
  Popconfirm,
  Collapse,
  Select,
  DatePicker,
  List,
  InputNumber,
  TimePicker,
  Checkbox,
  message,
} from "antd";
import {
  MenuUnfoldOutlined,
  MenuFoldOutlined,
  UserOutlined,
  VideoCameraOutlined,
  UploadOutlined,
  DeploymentUnitOutlined,
  SearchOutlined,
  EditOutlined,
  PlusOutlined,
  SaveOutlined,
  ShoppingCartOutlined,
  DeleteOutlined,
} from "@ant-design/icons";

import "./styles.scss";

import moment from "moment";
import {
  getData,
  editItem,
  addItem,
  deleteItem,
  updateItem,
} from "../../../Redux/actions/crudActions";
import { setPrice } from "../../../Redux/actions/productActions";
import {
  addCartItem,
  getCart,
  deleteCartItem,
  editCartItem,
  clearCart,
} from "../../../Redux/actions/cartActions";
import {
  createPackage,
  getPackageData,
  setPackage,
  deletePackagetItem,
  editPackageItem,
  attachSource,
} from "../../../Redux/actions/packageActions";

import { errorParser } from "../../../utils/helpers";

import CreateForm from "../../Generic/CreateForm";
import InputSelect from "../../Generic/InputSelect";
import ImageChecker from "../../Generic/ImageChecker";
import PackageDetail from "../PackageDetail";
import PackageSteps from "../PackageSteps";
import parse from "path-parse";

import PurchasingAddEdit from "../../purchasing/PurchasingAddEdit";

const { RangePicker } = DatePicker;
const { Panel } = Collapse;
const { Option } = Select;

const Index = ({
  CurrentSelected,
  currentTab,
  onCloseModal,
  onCancelmodal,
}) => {
  const dispatch = useDispatch();
  const { user, cart, crudData } = useSelector(
    (state) => ({
      user: state.auth.user,
      cart: state.cart.data,
      crudData: state.packages.data,
    }),
    shallowEqual
  );

  const [isModalVisible, setIsModalVisible] = useState(false);
  const [modalWidth, setmodalWidth] = useState("80%");
  const [loading, setLoading] = useState(false);

  const [somethingChanged, setSomethingChanged] = useState(false);

  const [localItems, setLocalItems] = useState([]);
  const [internationalItems, setInternationalItems] = useState([]);

  const [purchaseItem, setPurchaseItem] = useState(null);

  // useEffect(() => {
  //   console.log(localItems)
  //   console.log(internationalItems)

  // },[localItems,internationalItems]);

  const getSummary = () => {
    var filteredArr = crudData.filter((x) => CurrentSelected.includes(x.id));
    // console.log(filteredArr)
    if (currentTab == "pending" || currentTab == "toPack") {
      newPackSummary(filteredArr);
    } else {
      oldPackSummary(filteredArr);
    }
  };

  const newPackSummary = async (packs) => {
    var allItems = [];
    packs.map((pk) => {
      allItems.push(...pk.items);
    });
    var existingItems = [];

    allItems.map((ex) => {
      if (!existingItems.includes(ex.product)) {
        existingItems.push(ex.product);
      }
    });

    var consolidatedItems = [];
    existingItems.map((itid) => {
      var total = 0;
      var itx = null;
      allItems.map((ex) => {
        if (itid == ex.product) {
          total = total + ex.quantity;
          itx = {
            product: ex.product,
            product_name: ex.product_name,
            unit: ex.unit,
          };
        }
      });
      itx["quantity"] = total;
      if (itx) {
        consolidatedItems.push(itx);
      }
    });
    var readyItems = await dispatch(attachSource(consolidatedItems));
    var local = [];
    var international = [];
    readyItems.map((itm) => {
      if (itm.regionalization) {
        if (itm.regionalization == "international") {
          var itemx = itm;

          itemx["cost_rmb_adjusted_to_peso"] =
            parseFloat(itemx.cost_rmb) *
            (parseFloat(itemx.exchangerate) * 1.05).toFixed(2);

          international.push(itemx);
        } else {
          var tobuy = itm.quantity;
          if (itm[`${user.branch}_count`]) {
            if (
              parseFloat(itm[`${user.branch}_count`]) < parseFloat(itm.quantity)
            ) {
              tobuy =
                parseFloat(itm.quantity) -
                parseFloat(itm[`${user.branch}_count`]);
            } else {
              tobuy = 0;
            }
          }
          itm["tobuy"] = tobuy;
          local.push(itm);
        }
      } else {
        local.push(itm);
      }
    });
    setLocalItems(local);
    setInternationalItems(international);
    setIsModalVisible(true);
  };

  const oldPackSummary = async (packs) => {
    var allItems = [];
    packs.map((pk) => {
      pk.items.map((it) => {
        var ix = {
          ...it,
        };
        if (ix.cost_rmb_adjusted && pk.exchange_rate) {
          ix["cost_rmb_adjusted_to_peso"] =
            parseFloat(ix.cost_rmb_adjusted) *
            parseFloat(pk.exchange_rate).toFixed(2) *
            1.05;
        }
        allItems.push(ix);
      });
    });
    var existingItems = [];

    allItems.map((ex) => {
      if (!existingItems.includes(ex.product)) {
        existingItems.push(ex.product);
      }
    });

    var consolidatedItems = [];
    existingItems.map((itid) => {
      var total = 0;
      var itx = null;
      var pricepoints = [];
      allItems.map((ex) => {
        if (itid == ex.product) {
          itx = {
            ...ex,
            product: ex.product,
            product_name: ex.product_name,
            name: ex.product_name,
            unit: ex.unit,
          };
          if (ex.regionalization == "international") {
            if (!pricepoints.includes(ex.cost_rmb_adjusted_to_peso)) {
              pricepoints.push(ex.cost_rmb_adjusted_to_peso);
            }
          } else {
            if (!pricepoints.includes(ex.cost_peso)) {
              pricepoints.push(ex.cost_peso);
            }
          }
        }
      });
      var subtotal = 0;
      var pricelist = [];
      pricepoints.map((pp) => {
        var ppqty = 0;
        allItems.map((ex) => {
          if (itid == ex.product) {
            if (ex.regionalization == "international") {
              if (pp == ex.cost_rmb_adjusted_to_peso) {
                ppqty = ppqty + parseFloat(ex.quantity);
                var costcheck = ex.cost_rmb_adjusted_to_peso
                  ? ex.cost_rmb_adjusted_to_peso
                  : 0;
                subtotal =
                  subtotal + parseFloat(costcheck) * parseFloat(ex.quantity);
              }
            } else {
              if (pp == ex.cost_peso) {
                ppqty = ppqty + parseFloat(ex.quantity);
                var costcheck = ex.cost_peso ? ex.cost_peso : 0;
                subtotal =
                  subtotal + parseFloat(costcheck) * parseFloat(ex.quantity);
              }
            }
          }
        });
        total = total + parseFloat(ppqty);
        var newpriceitem = {
          quantity: parseFloat(ppqty).toFixed(2),
          cost: parseFloat(pp).toFixed(2),
        };
        pricelist.push(newpriceitem);
      });

      itx["subtotal"] = subtotal;
      itx["pricelist"] = pricelist;
      itx["quantity"] = total;
      if (itx) {
        consolidatedItems.push(itx);
      }
    });

    var local = [];
    var international = [];
    // console.log(consolidatedItems)
    consolidatedItems.map((itm) => {
      if (itm.regionalization) {
        if (itm.regionalization == "international") {
          var itemx = itm;
          international.push(itemx);
        } else {
          local.push(itm);
        }
      } else {
        local.push(itm);
      }
    });
    // console.log(local)
    // console.log(international)

    setLocalItems(local);
    setInternationalItems(international);
    setIsModalVisible(true);
  };

  const footer = () => {
    return <div className="cartFooter"></div>;
  };

  const summarycopy = () => {
    var filteredArr = crudData.filter((x) => CurrentSelected.includes(x.id));
    var destinations = [];
    filteredArr.map((pk) => {
      if (!destinations.includes(pk.destination)) {
        destinations.push(pk.destination);
      }
    });
    var summaryItems = [];
    var costTotal = 0;
    destinations.map((currentDest) => {
      var currentDestsum = {};
      var destItems = filteredArr.filter((x) => currentDest == x.destination);
      var skus = [];
      var regionsku = [];
      localItems.map((itx) => {
        if (!regionsku.includes(itx.product)) {
          regionsku.push(itx.product);
        }
      });
      var currentItems = [];
      destItems.map((cpk) => {
        cpk.items.map((itx) => {
          if (!skus.includes(itx.product) && regionsku.includes(itx.product)) {
            skus.push(itx.product);
            currentDestsum["destination"] = cpk.destination;
            currentDestsum["destination_name"] = cpk.destination_name;
          }
          currentItems.push(itx);
        });
      });
      var destProducts = [];
      var itemscostTotal = 0;
      skus.map((sku) => {
        var skucollection = currentItems.filter((x) => sku == x.product);

        var qty = 0;
        var newThing = {};
        skucollection.map((y) => {
          newThing["product"] = y.product;
          newThing["product_name"] = y.product_name;
          newThing["unit"] = y.unit;
          qty = parseFloat(qty) + parseFloat(y.quantity);
        });
        newThing["quantity"] = qty;
        var source = localItems.filter((x) => newThing.product == x.product);
        if (source[0]) {
          var costcheck = source[0].cost_peso ? source[0].cost_peso : 0;

          newThing["cost"] = costcheck;
          newThing["subtotal"] = parseFloat(costcheck) * qty;
          itemscostTotal = itemscostTotal + parseFloat(costcheck) * qty;
        }
        destProducts.push(newThing);
      });
      currentDestsum["items"] = destProducts;
      currentDestsum["subtotal"] = itemscostTotal;
      costTotal = costTotal + itemscostTotal;
      summaryItems.push(currentDestsum);
    });

    var copystring = "```" + "\r\n";
    copystring =
      copystring +
      `Good Afternoon po request lang po petty cash for tom. ` +
      "\r\n" +
      `${moment().add(1, "days").format("dddd, LL")} ` +
      "\r\n";
    copystring = copystring + `____________________` + "\r\n" + "\r\n";
    summaryItems.map((summaryit) => {
      copystring =
        copystring + `For ${summaryit.destination_name}:` + "\r\n" + "\r\n";
      summaryit.items.map((xitem) => {
        copystring =
          copystring +
          `► ${xitem.product_name} - ${xitem.quantity} ${xitem.unit}${
            xitem.quantity > 1 ? "s" : ""
          }  (${xitem.subtotal.toFixed(2)})` +
          "\r\n";
      });
      copystring =
        copystring +
        "\r\n" +
        `${summaryit.destination_name} total: ${numberWithCommas(
          summaryit.subtotal.toFixed(2)
        )}` +
        "\r\n";
      copystring = copystring + `____________________` + "\r\n" + "\r\n";
    });

    copystring = copystring + `Overall petty cash: ` + "\r\n";
    copystring = copystring + `${costTotal.toFixed(2)}` + "\r\n";
    copystring = copystring + "```";
    navigator.clipboard.writeText(copystring);
    message.success("message copied to clipboard");
  };

  const summarycopy2 = () => {
    var copystring = "```" + "\r\n";
    copystring =
      copystring +
      `Good Afternoon po request lang po petty cash for tom. ` +
      "\r\n" +
      `${moment().add(1, "days").format("dddd, LL")} ` +
      "\r\n";
    copystring = copystring + `____________________` + "\r\n" + "\r\n";
    var costTotal = 0;
    localItems.map((xitem) => {
      if (parseFloat(xitem.tobuy) > 0) {
        costTotal =
          costTotal + parseFloat(xitem.cost_peso) * parseFloat(xitem.tobuy);
        copystring =
          copystring +
          `► ${xitem.product_name} - ${xitem.tobuy} ${xitem.unit}${
            xitem.tobuy > 1 ? "s" : ""
          }  (${(parseFloat(xitem.cost_peso) * parseFloat(xitem.tobuy)).toFixed(
            2
          )})` +
          "\r\n";
      }
    });

    copystring = copystring + `____________________` + "\r\n" + "\r\n";

    copystring = copystring + `Overall petty cash: ` + "\r\n";
    copystring = copystring + `${costTotal.toFixed(2)}` + "\r\n";
    copystring = copystring + "```";
    navigator.clipboard.writeText(copystring);
    message.success("message copied to clipboard");
  };

  const generatepurchaseItem = () => {
    var costTotal = 0;
    var newlist = [];
    var newPackList = [];
    var filteredArr = crudData.filter((x) => CurrentSelected.includes(x.id));

    var packList = filteredArr.map((pk) => {
      var newpk = {
        id: pk.id,
        destination: pk.destination,
        destination_name: pk.destination_name,
      };

      if (pk.purchase_request) {
        newpk["preexisting_request"] = pk.purchase_request;
      }

      return newpk;
    });

    localItems.map((xitem) => {
      if (parseFloat(xitem.tobuy) > 0) {
        costTotal =
          costTotal + parseFloat(xitem.cost_peso) * parseFloat(xitem.tobuy);
        // copystring = copystring + `► ${xitem.product_name} - ${xitem.tobuy} ${xitem.unit}${xitem.tobuy > 1 ? 's' :'' }  (${(parseFloat(xitem.cost_peso) * parseFloat(xitem.tobuy)).toFixed(2)})`+'\r\n'
        xitem["cost_peso_new"] = xitem.cost_peso;
        newlist.push(xitem);
      }
    });

    var newrequerst = {
      status: "toApprove",
      created_by: user.id,
      created_by_name: user.name,
      created_at: moment().format("YYYY-MM-DD HH:mm:ss"),
      created_for: moment().add(1, "days").format("YYYY-MM-DD HH:mm:ss"),
      costTotal: costTotal,
      package_list: packList,
      items: newlist,
    };

    setPurchaseItem(newrequerst);
  };

  const renderlocal = () => {
    var columns = [
      {
        title: "",
        render: (text, record, index) => {
          return (
            <ImageChecker
              url={`${process.env.REACT_APP_AWS_S3}${record.product}.png`}
              success={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}${record.product}.png`}
                  alt="image"
                  className={"prodSummaryimage"}
                />
              }
              fail={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}logo192.png`}
                  alt="image"
                  className={"prodSummaryimage"}
                />
              }
            />
          );
        },
      },
      {
        title: "name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "quantity",
        dataIndex: "quantity",
        key: "quantity",
        render: (text, record, index) => {
          return `${text} ${record.unit}`;
        },
      },
    ];

    var stockcount = [
      {
        title: "in stock",
        className: "centercell",
        render: (text, record, index) => {
          var stockcount = 0;
          if (record[`${user.branch}_count`]) {
            stockcount = parseFloat(record[`${user.branch}_count`]);
          }
          return `${stockcount.toFixed(2)}`;
        },
      },
    ];

    if (currentTab == "pending" || currentTab == "toPack") {
      columns = columns.concat(stockcount);
    }

    if (
      user.role == "admin" ||
      user.role == "manager" ||
      user.role == "warehouse"
    ) {
      var tobuycolumn = [
        {
          title: "To Buy",
          dataIndex: "tobuy",
          key: "tobuy",
          render: (text, record, index) => {
            var tobuycomp = record.quantity;
            if (record[`${user.branch}_count`]) {
              if (
                parseFloat(record[`${user.branch}_count`]) <
                parseFloat(record.quantity)
              ) {
                tobuycomp =
                  parseFloat(record.quantity) -
                  parseFloat(record[`${user.branch}_count`]);
              } else {
                tobuycomp = 0;
              }
            }
            return (
              <InputNumber
                min={tobuycomp}
                defaultValue={parseFloat(text).toFixed(2)}
                onChange={(e) => {
                  var newlsit = [...localItems];
                  newlsit[index]["tobuy"] = e;
                  setLocalItems(newlsit);
                }}
              />
            );
          },
        },
        {
          title: "unit cost",
          dataIndex: "cost_peso",
          key: "cost_peso",
        },
      ];

      var priceSummaryColumn = [
        {
          title: "prices",
          render: (text, record, index) => {
            pricecolumn = [
              {
                title: "cost",
                dataIndex: "cost",
                key: "cost",
              },
              {
                title: "qty",
                dataIndex: "quantity",
                key: "quantity",
              },
            ];
            return (
              <div>
                <Table
                  columns={pricecolumn}
                  dataSource={record.pricelist}
                  pagination={false}
                  size={"small"}
                />{" "}
              </div>
            );
          },
        },
      ];

      if (currentTab == "pending" || currentTab == "toPack") {
        columns = columns.concat(tobuycolumn);
      } else {
        if (user.role == "admin" || user.role == "manager") {
          columns = columns.concat(priceSummaryColumn);
        }
      }

      var pricecolumn = [
        {
          title: "subtotal",
          render: (text, record, index) => {
            if (currentTab == "pending" || currentTab == "toPack") {
              return `${numberWithCommas(
                (
                  parseFloat(record.tobuy) * parseFloat(record.cost_peso)
                ).toFixed(2)
              )} `;
            } else {
              if (record.subtotal) {
                return numberWithCommas(parseFloat(record.subtotal).toFixed(2));
              } else {
                return numberWithCommas(parseFloat(0).toFixed(2));
              }
            }
          },
        },
      ];
      columns = columns.concat(pricecolumn);
    }

    var total = 0;

    localItems.map((i) => {
      if (currentTab == "pending" || currentTab == "toPack") {
        var costcheck = i.cost_peso ? i.cost_peso : 0;
        total = (
          parseFloat(total) +
          parseFloat(i.tobuy) * parseFloat(costcheck)
        ).toFixed(2);
      } else {
        var costcheck = i.subtotal ? i.subtotal : 0;
        total = (parseFloat(total) + parseFloat(costcheck)).toFixed(2);
      }
    });
    // console.log(localItems)

    return (
      <div className="summarylist">
        <Divider orientation="left">Local Items</Divider>
        <Table
          columns={columns}
          dataSource={localItems}
          pagination={false}
          size={"small"}
          rowClassName={(record) => {
            var tobuycomp = record.quantity;
            if (record.tobuy) {
              tobuycomp = record.tobuy;
            } else if (record[`${user.branch}_count`]) {
              if (
                parseFloat(record[`${user.branch}_count`]) <
                parseFloat(record.quantity)
              ) {
                tobuycomp =
                  parseFloat(record.quantity) -
                  parseFloat(record[`${user.branch}_count`]);
              } else {
                tobuycomp = 0;
              }
            }
            if (currentTab == "pending" || currentTab == "toPack") {
              if (tobuycomp > 0) {
                return "buythisrow";
              }
            }
          }}
        />
        {user.role == "admin" || user.role == "manager" ? (
          <div className="summaryfooter">
            <div>
              <span className="bold">total: </span>
              <span>₱{numberWithCommas(total)}</span>
            </div>
            {currentTab == "toPack" ? (
              <Button
                type="primary"
                onClick={() => {
                  generatepurchaseItem();
                }}
                disabled={total <= 0}
              >
                Petty Cash Request
              </Button>
            ) : null}
          </div>
        ) : null}
      </div>
    );
  };

  const renderInternational = () => {
    var columns = [
      {
        title: "",
        render: (text, record, index) => {
          return (
            <ImageChecker
              url={`${process.env.REACT_APP_AWS_S3}${record.product}.png`}
              success={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}${record.product}.png`}
                  alt="image"
                  className={"prodSummaryimage"}
                />
              }
              fail={
                <img
                  src={`${process.env.REACT_APP_AWS_S3}logo192.png`}
                  alt="image"
                  className={"prodSummaryimage"}
                />
              }
            />
          );
        },
      },
      {
        title: "name",
        dataIndex: "name",
        key: "name",
      },
      {
        title: "quantity",
        dataIndex: "quantity",
        key: "quantity",
        render: (text, record, index) => {
          return `${text} ${record.unit}`;
        },
      },
    ];

    var stockcount = [
      {
        title: "in stock",
        render: (text, record, index) => {
          var stockcount = 0;
          if (record[`${user.branch}_count`]) {
            stockcount = parseFloat(record[`${user.branch}_count`]);
          }
          return `${stockcount.toFixed(2)}`;
        },
      },
    ];
    if (currentTab == "pending" || currentTab == "toPack") {
      columns = columns.concat(stockcount);
    }

    if (user.role == "admin") {
      var costcolumn = [
        {
          title: "adjusted (5%)",
          dataIndex: "cost_rmb_adjusted_to_peso",
          key: "cost_rmb_adjusted_to_peso",
          render: (text, record, index) => {
            if (text) {
              return `${parseFloat(text).toFixed(2)}`;
            }
          },
        },
      ];

      var priceSummaryColumn = [
        {
          title: "prices",
          render: (text, record, index) => {
            pricecolumn = [
              {
                title: "adjusted (5%)",
                dataIndex: "cost_rmb_adjusted_to_peso",
                key: "cost_rmb_adjusted_to_peso",
                render: (text, record, index) => {
                  if (text) {
                    return `${parseFloat(text).toFixed(2)}`;
                  }
                },
              },
              {
                title: "qty",
                dataIndex: "quantity",
                key: "quantity",
              },
            ];
            return (
              <div>
                <Table
                  columns={pricecolumn}
                  dataSource={record.pricelist}
                  pagination={false}
                  size={"small"}
                />{" "}
              </div>
            );
          },
        },
      ];

      if (currentTab == "pending" || currentTab == "toPack") {
        columns = columns.concat(costcolumn);
      } else {
        columns = columns.concat(priceSummaryColumn);
      }

      var pricecolumn = [
        {
          title: "subtotal",
          render: (text, record, index) => {
            if (currentTab == "pending" || currentTab == "toPack") {
              return `${numberWithCommas(
                (
                  parseFloat(record.quantity) *
                  parseFloat(record.cost_rmb) *
                  parseFloat(record.exchangerate) *
                  1.05
                ).toFixed(2)
              )} `;
            } else {
              if (record.subtotal) {
                return numberWithCommas(parseFloat(record.subtotal).toFixed(2));
              } else {
                return numberWithCommas(parseFloat(0).toFixed(2));
              }
            }
          },
        },
      ];
      columns = columns.concat(pricecolumn);
    }

    var total = 0;
    internationalItems.map((i) => {
      if (currentTab == "pending" || currentTab == "toPack") {
        var costcheck = i.cost_rmb ? i.cost_rmb : 0;
        total = (
          parseFloat(total) +
          parseFloat(i.quantity) *
            parseFloat(costcheck) *
            parseFloat(i.exchangerate) *
            1.05
        ).toFixed(2);
      } else {
        var costcheck = i.subtotal ? i.subtotal : 0;
        total = (parseFloat(total) + parseFloat(costcheck)).toFixed(2);
      }
    });

    // console.log(localItems)

    return (
      <div className="summarylist">
        <Divider orientation="left">International Items</Divider>
        <Table
          columns={columns}
          dataSource={internationalItems}
          pagination={false}
          size={"small"}
          rowClassName={(record) => {
            var currentcount = 0;
            if (record[`${user.branch}_count`]) {
              currentcount = record[`${user.branch}_count`];
            }

            if (currentTab == "pending" || currentTab == "toPack") {
              if (currentcount < record.quantity) {
                return "kulangrow";
              }
              if (currentcount == record.quantity) {
                return "saktorow";
              }
            }
          }}
        />
        {user.role == "admin" ? (
          <div className="summaryfooter">
            <div>
              <span className="bold">total: </span>
              <span>₱{numberWithCommas(total)}</span>
            </div>
          </div>
        ) : null}
      </div>
    );
  };

  const closeModal = () => {
    if (!loading) {
      setLocalItems([]);
      setInternationalItems([]);
      setPurchaseItem(null);
      setIsModalVisible(false);
      if (somethingChanged) {
        onCloseModal();
        setSomethingChanged(false);
      }
    }
  };

  return (
    <>
      <div className="packSummaryButton">
        <Button
          onClick={() => {
            getSummary();
          }}
          disabled={CurrentSelected == null || CurrentSelected.length < 1}
          type={"primary"}
          shape={"round"}
        >
          Get Summary
        </Button>
      </div>
      {currentTab == "toPack" ? (
        <PurchasingAddEdit
          purchaseItem={purchaseItem}
          mode="add"
          onCancelmodal={() => {}}
        ></PurchasingAddEdit>
      ) : null}
      {isModalVisible ? (
        <Modal
          title={"Package Summary"}
          visible={isModalVisible}
          footer={footer()}
          onCancel={() => {
            closeModal();
            onCancelmodal();
          }}
          width={"50vw"}
        >
          <div className="cart-content">
            {localItems.length > 0 ? renderlocal() : null}
            {internationalItems.length > 0 ? renderInternational() : null}
          </div>
        </Modal>
      ) : null}
    </>
  );
};

export default Index;
